"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const sunshine_1 = require("@shinetools/sunshine");
const Divider_1 = __importDefault(require("./components/Divider"));
const SunshineIcon_1 = __importDefault(require("./components/SunshineIcon"));
const SunshineTag_1 = __importDefault(require("./components/SunshineTag"));
const Text_1 = __importDefault(require("./components/Text"));
const radii_1 = __importDefault(require("./foundations/radii"));
const space_1 = __importDefault(require("./foundations/space"));
const typography_1 = __importDefault(require("./foundations/typography"));
const theme = {
    colors: sunshine_1.colors,
    components: {
        Divider: Divider_1.default,
        SunshineIcon: SunshineIcon_1.default,
        SunshineTag: SunshineTag_1.default,
        Text: Text_1.default,
    },
    config: react_1.theme.config,
    radii: radii_1.default,
    semanticTokens: {
        colors: {
            ...sunshine_1.tokens,
        },
    },
    space: space_1.default,
    // we set the styles to undefined to avoid overriding the default styles of the parent theme, see https://github.com/chakra-ui/chakra-ui/discussions/5180#discussioncomment-4823098
    styles: undefined,
    ...typography_1.default,
};
exports.default = theme;
